import React from 'react';
import { ControlLabel } from 'react-bootstrap';

// Structure:
// props: {
//   label:
// }

const SrLabel = (props) => {
  return (
    <ControlLabel className="sr-only">{ props.children }</ControlLabel>
  );
};

export default SrLabel;
